import React, { useRef, useState, useEffect } from "react";
import { toPng } from "html-to-image";
import TicketSalon from "./TicketSalon";
import Ticket from "./Ticket";
import Entrada from "./Entrada";
import "../CSS/Prueba.css";
import { Box, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

export default function Prueba(props) {
  const {
    salon,
    nombre,
    fecha,
    nombreParticipante,
    asientos,
    id,
    idTicket,
    fechaCompra,
    comidas,
    nroTicket,
    tipoEvento,
    lugar,
    invitados,
  } = props;

  const [imageUrl, setImageUrl] = useState(null);
  const containerRef = useRef(null);
  const containerRefSalonPC = useRef(null);
  const [tablesSeats, setTablesSeats] = useState([]);
  const [asientosString, setAsientosString] = useState("");
  const [esCelular, setEsCelular] = useState(true);
  const [datosCargados, setDatosCargados] = useState(true);

  // ✅ refs para cada invitado y para ticket único
  const invitadosRefs = useRef([]);
  const ticketUnicoRef = useRef(null);

  function groupTablesSeats() {
    const mesas = {};
    asientos
      .split(",")
      .sort()
      .forEach((asiento) => {
        const numeroMesa = asiento.slice(0, -1);
        const letraAsiento = asiento.slice(-1);
        if (!mesas[numeroMesa]) {
          mesas[numeroMesa] = [];
        }
        mesas[numeroMesa].push(letraAsiento);
      });
    setTablesSeats(mesas);
  }

  const handleConvert = () => {
    if (lugar === "Salon de eventos") {
      toPng(containerRefSalonPC.current)
        .then((dataUrl) => setImageUrl(dataUrl))
        .catch(() => {});
    } else {
      toPng(containerRef.current)
        .then((dataUrl) => setImageUrl(dataUrl))
        .catch(() => {});
    }
  };

  const handleDownload = () => {
    handleConvert();
    new Promise((res) => setTimeout(res, 2000));
    const downloadLink = document.createElement("a");
    downloadLink.href = imageUrl;
    downloadLink.download = nombre + " " + nombreParticipante;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  // ✅ descarga individual de cada invitado
  const handleDownloadInvitado = (index, invitado) => {
    const ref = invitadosRefs.current[index];
    if (!ref) return;
    toPng(ref)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${nombre} - ${invitado.nombre}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => console.error("Error al exportar ticket:", error));
  };

  // ✅ descarga del ticket único (sin invitados)
  const handleDownloadUnico = () => {
    if (!ticketUnicoRef.current) return;
    toPng(ticketUnicoRef.current)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `${nombre} - ${nombreParticipante}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => console.error("Error al exportar ticket único:", error));
  };

  useEffect(() => {
    handleConvert();
  }, [asientosString, nombre, esCelular, asientos, tablesSeats]);

  useEffect(() => {
    if (asientos) groupTablesSeats();
  }, [asientos]);

  useEffect(() => {
    if (tablesSeats) {
      let resultado = "";
      Object.entries(tablesSeats).map(
        ([numeroMesa, letraAsiento]) =>
          (resultado += `Mesa ${numeroMesa} (${letraAsiento.sort().join(",")}) \n `)
      );
      if (resultado) setAsientosString(resultado.toString());
    }
  }, [tablesSeats]);

  useEffect(() => {
    const esCel = /Mobi|Android/i.test(navigator.userAgent);
    setEsCelular(esCel);
    setDatosCargados(false);
  }, []);

  return (
    <div className="congrats">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          marginX: "20px",
        }}
      >
        <CheckCircleOutlineIcon sx={{ color: "#2ecc71", fontSize: 70, mb: 2 }} />
        <Typography variant="h5" fontWeight="bold" color="text.primary" sx={{ mb: 3 }}>
          ¡Registro Exitoso!
        </Typography>
      </Box>

      <div className="ticket-card">
        {datosCargados ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              margin: "0px auto",
              textAlign: "center",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div style={{ verticalAlign: "middle", display: "block" }}>
              <div>
                <img
                  style={{ height: "300px" }}
                  src={require(`../img/docucargando.gif`)}
                  alt="esperando"
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="ticket">
            {/* CASO SALÓN DE EVENTOS */}
            {lugar === "Salon de eventos" ? (
              <div
                ref={containerRefSalonPC}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {esCelular ? (
                  <Entrada
                    salon={salon}
                    nombre={nombre}
                    fecha={fecha}
                    nombreParticipante={nombreParticipante}
                    asientos={asientos}
                    id={id}
                    idTicket={idTicket}
                    fechaCompra={fechaCompra}
                    comidas={comidas}
                    nroTicket={nroTicket}
                    asientosString={asientosString}
                    handleConvert={handleConvert}
                    lugar={lugar}
                    tipoEvento={tipoEvento}
                  />
                ) : (
                  <TicketSalon
                    salon={salon}
                    nombre={nombre}
                    fecha={fecha}
                    nombreParticipante={nombreParticipante}
                    asientos={asientos}
                    id={id}
                    idTicket={idTicket}
                    fechaCompra={fechaCompra}
                    comidas={comidas}
                    nroTicket={nroTicket}
                    asientosString={asientosString}
                    handleConvert={handleConvert}
                    lugar={lugar}
                  />
                )}
              </div>
            ) : (
              // CASO NO SALÓN DE EVENTOS
              <div
                ref={containerRef}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {Array.isArray(invitados) && invitados.length > 0 ? (
                  <div style={{ marginTop: "2em" }}>
                    {invitados.map((invitado, index) => (
                      <div
                        key={index}
                        style={{
                          marginBottom: "2.5em",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          width: "100%",
                        }}
                      >
                        {/* Texto no incluido */}
                        <Typography
                          variant="h6"
                          fontWeight="bold"
                          color="primary"
                          sx={{ mb: 1, textAlign: "left", width: "100%" }}
                        >
                          Invitado {index + 1}: {invitado.nombre}
                        </Typography>

                        {/* ✅ Solo el ticket dentro del ref */}
                        <div
                          ref={(el) => (invitadosRefs.current[index] = el)}
                          style={{ display: "inline-block" }}
                        >
                          {esCelular ? (
                            <Entrada
                              salon={salon}
                              nombre={nombre}
                              fecha={fecha}
                              nombreParticipante={invitado.nombre}
                              asientos={invitado.asiento}
                              id={id}
                              idTicket={idTicket}
                              fechaCompra={fechaCompra}
                              comidas={comidas}
                              nroTicket={nroTicket}
                              asientosString={invitado.asiento}
                              handleConvert={handleConvert}
                              tipoEvento={tipoEvento}
                              lugar={lugar}
                            />
                          ) : (
                            <Ticket
                              salon={salon}
                              nombre={nombre}
                              fecha={fecha}
                              nombreParticipante={invitado.nombre}
                              asientos={invitado.asiento}
                              id={id}
                              idTicket={idTicket}
                              fechaCompra={fechaCompra}
                              comidas={comidas}
                              nroTicket={nroTicket}
                              handleConvert={handleConvert}
                              tipoEvento={tipoEvento}
                              lugar={lugar}
                            />
                          )}
                        </div>

                        {/* Botón fuera del ref */}
                        <div
                          className="boton-contenedor"
                          style={{
                            marginTop: "1em",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <button
                            className="boton"
                            onClick={() => handleDownloadInvitado(index, invitado)}
                          >
                            Descargar ticket
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  // ✅ CASO SIN INVITADOS
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: "2em",
                    }}
                  >
                    {/* ref envuelve solo el ticket */}
                    <div ref={ticketUnicoRef}>
                      {esCelular ? (
                        <Entrada
                          salon={salon}
                          nombre={nombre}
                          fecha={fecha}
                          nombreParticipante={nombreParticipante}
                          asientos={asientos}
                          id={id}
                          idTicket={idTicket}
                          fechaCompra={fechaCompra}
                          comidas={comidas}
                          nroTicket={nroTicket}
                          asientosString={asientos}
                          handleConvert={handleConvert}
                          tipoEvento={tipoEvento}
                          lugar={lugar}
                        />
                      ) : (
                        <Ticket
                          salon={salon}
                          nombre={nombre}
                          fecha={fecha}
                          nombreParticipante={nombreParticipante}
                          asientos={asientos}
                          id={id}
                          idTicket={idTicket}
                          fechaCompra={fechaCompra}
                          comidas={comidas}
                          nroTicket={nroTicket}
                          handleConvert={handleConvert}
                          tipoEvento={tipoEvento}
                          lugar={lugar}
                        />
                      )}
                    </div>

                    {/* Botón fuera del ref */}
                    <div
                      className="boton-contenedor"
                      style={{
                        marginTop: "1em",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <button className="boton" onClick={handleDownloadUnico}>
                        Descargar ticket
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      <div style={{ paddingBottom: "3em", textAlign: "center" }}>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
          Descargue, imprima o presente el ticket el día del evento.
        </Typography>
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
          <Box component="span" sx={{ fontWeight: "900", textDecoration: "underline" }}>
            Nota:
          </Box>{" "}
          No podrá moverse de los asientos seleccionados.
        </Typography>
      </div>
    </div>
  );
}
